<template>
  <div class="login-btns-container mb-8">
    <h5 v-if="!localSignIn" class="login-title text-center mb-12">Pierakstīties</h5>
    <div v-if="!localSignIn" class="login-btns">
      <div class="login-btn-cell">
        <v-btn height="44" rounded="pill" flat color="eklase" @click.prevent="authEklase">
          <img :src="'/v2/images/login-logos/eklase-logo.png'" alt="Eklase logo" class="mr-1" />
          E-klase
        </v-btn>
      </div>
      <div class="login-btn-cell">
        <v-btn height="44" rounded="pill" flat color="mykoob" @click.prevent="authMykoob">
          <img :src="'/v2/images/login-logos/mykoob-logo.png'" alt="Mykoob logo" class="mr-1" />
          <span class="text-white">Mykoob</span>
        </v-btn>
      </div>
    </div>
    <div v-if="!localSignIn" class="login-btns">
      <div class="login-btn-cell">
        <v-btn height="44" rounded="pill" flat color="eliis" @click.prevent="authEliis">
          <img :src="'/v2/images/login-logos/eliis-logo.png'" alt="ELIIS logo" class="mr-1" />
          <span class="text-white">Eliis</span>
        </v-btn>
      </div>
      <div class="login-btn-cell">
        <v-btn height="44" rounded="pill" flat color="mailogin" @click.prevent="localSignIn = true">
          <img :src="'/v2/images/login-logos/mail-logo.png'" alt="Mail logo" class="mr-1" />
          E-pasts
        </v-btn>
      </div>
    </div>
    <login-other-sign-in-options v-if="!localSignIn" />
    <login-local-sign-in-option v-if="localSignIn" @return-to-main-sign-in="localSignIn = false" />
  </div>
</template>

<script>
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    return { userStore }
  },

  data() {
    return {
      localSignIn: false,
    }
  },

  computed: {
    oauth() {
      return useRuntimeConfig().public.oauth
    },
  },

  methods: {
    authEklase() {
      const { eklase } = this.oauth
      const params = new URLSearchParams({
        client_id: eklase.appId,
        redirect_uri: eklase.callbackUrl,
      })
      window.location = `${eklase.authUrl}?${params.toString()}`
    },

    authMykoob() {
      const { mykoob } = this.oauth
      const params = new URLSearchParams({
        client_id: mykoob.appId,
        redirect_uri: mykoob.callbackUrl,
        scope: mykoob.scope,
        response_type: mykoob.responseType,
      })
      window.location = `${mykoob.authUrl}?${params.toString()}`
    },

    authEliis() {
      const { eliis } = this.oauth
      const params = new URLSearchParams({
        client_id: eliis.appId,
        redirect_uri: eliis.callbackUrl,
        response_type: eliis.responseType,
      })
      // Has multiple scopes with
      window.location = `${eliis.authUrl}?${params.toString()}&scope=${eliis.scope.replaceAll("_", " ")}`
    },
  },
}
</script>

<style lang="sass" scoped>
.login-btns-container
  height: 264px
  display: flex
  flex-direction: column
  justify-items: center
  justify-content: center

.login-btns
  display: flex
  flex-wrap: wrap
  align-self: center
  justify-content: center

.login-btn-cell
  padding: 4px
  > *
    font-weight: bold
    width: 156px
</style>
